import * as React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import LogoDevIcon from "@mui/icons-material/LogoDev";

const item = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: "flex", overflow: "hidden", bgcolor: "secondary.light" }}
    >
      <Container sx={{ mt: 15, mb: 30, display: "flex", position: "relative" }}>
        <Box
          component="img"
          src="/images/curvylines.png"
          alt="curvy lines"
          sx={{ pointerEvents: "none", position: "absolute", top: -180 }}
        />
        <Grid container spacing={5} sx={{ zIndex: 1 }}>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Box
                component="img"
                src="/images/certlogo.png"
                alt="salesforce certified professional"
                sx={{ height: 200 }}
              />
              <Typography variant="h6" align="center" sx={{ my: 5 }}>
                Salesforce
              </Typography>
              <Typography variant="h5">
                {
                  "Need help building a custom Salesforce solution? Let us take the guesswork out of figuring out how to make Salesforce work for you."
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <CloudDoneIcon
                alt="Cloud Computing"
                color="success"
                sx={{ height: 200, fontSize: 125 }}
              />
              <Typography variant="h6" align="center" sx={{ my: 5 }}>
                Cloud Computing
              </Typography>
              <Typography variant="h5">
                Whether you're hosting your own servers, playing around with AI,
                or using services like AWS, we can help.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <LogoDevIcon
                alt="Traditional Development"
                color="primary"
                sx={{ height: 200, fontSize: 125 }}
              />
              <Typography variant="h6" align="center" sx={{ my: 5 }}>
                App Development
              </Typography>
              <Typography variant="h5">
                Need help developing custom solutions for your business? From
                desktop and server applications to DevOps and CI/CD, we can
                help.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
